//@ts-check
import {Button, RadioButton} from '@/components-v2/atoms'
import {Dropdown, SectionTitle} from '@/components-v2/molecules'
import {useSelectComboCategories} from '@/hooks/productCombo/useSelectComboCategories'
import {ComboProductTable} from './ComboProductTable'
import {ComboSubCategories} from './ComboSubCategories'

export const SelectComboCategories = () => {
  const {categoriesOptions, handleCategoryChange, selectedCategories} = useSelectComboCategories()

  return (
    <div className="flex flex-col gap-6">
      <div className="flex flex-col gap-4 rounded-lg bg-[var(--color-background-layer-01)] p-6">
        <SectionTitle label="Products" />
        <div className="flex items-center justify-between">
          <RadioButton items={['Category & Products']} reference="radio button" selected={true} />
          {/* <Toggle uiSchema={{label: 'Ignore SKU List'}} value={ignoreSkuList} updateValue={handleIgnoreSkuListToggle} /> */}
        </div>
        <div className="flex items-center justify-between">
          <Dropdown
            label="Display Category*"
            childList={categoriesOptions}
            setSelectedValue={handleCategoryChange}
            selectedValue={selectedCategories}
            selection="multiple"
            hideMenuListOnSelection={false}
            placeholder={
              selectedCategories.length === 0
                ? 'Select Display Categories'
                : selectedCategories.map(category => category.displayText).join(', ')
            }
          />
          <Button variant="secondary" size="medium" onClick={() => handleCategoryChange([])}>
            Reset
          </Button>
        </div>
        <div className="h-px bg-[var(--secondary-800)]" />
        <ComboSubCategories />
      </div>
      <ComboProductTable />
    </div>
  )
}
